enum Product {
  CLASSIC = 'CLASSIC',
  BRANDED = 'BRANDED',
  PREMIUM = 'PREMIUM',
}

export enum PriceVisibility {
  SHOW_RETAIL_PRICE = 'SHOW_RETAIL_PRICE',
  SHOW_DISCOUNTED_PRICE = 'SHOW_DISCOUNTED_PRICE',
  HIDE_PRICE = 'HIDE_PRICE',
}

export enum PricingModel {
  HORIZON = 'HORIZON',
  FIXED = 'FIXED',
}

export default Product;
